import { Array } from "runtypes";
import { Preference } from "./Preference";

export const PreferenceListResponse = Array(Preference);
